/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".show-task-popup-container[_ngcontent-%COMP%]{background-color:#f0f0f0}"];
export { styles as styles };

